// The save lifecycle of the agent record, shared by useNovaPromptState (the
// source of truth) and the Studio shell header (the display).
export const SaveState = {
	Saved: 'saved',
	Saving: 'saving',
	Unsaved: 'unsaved',
	Error: 'error',
} as const;
export type SaveState = (typeof SaveState)[keyof typeof SaveState];

// Single source of truth for when the explicit Save action (header button, ⌘S/Ctrl+S) should be
// a no-op: there is nothing to save when the draft is clean, a second trigger while one save is
// already in flight must not fire a duplicate mutation, and — see `isReady` — a save must never
// fire before the selected agent's real content has actually loaded into the draft, or it would
// persist blank/stale content over the agent's real prompt bodies.
export function isSaveDisabled(isDirty: boolean, saveState: SaveState, isReady = true): boolean {
	return !isDirty || saveState === SaveState.Saving || !isReady;
}
